var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuoteMark = function SvgQuoteMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6081c42f-5de9-43ed-a81e-a2bcea15ae12",
    viewBox: "0 0 1001.8 905.7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.2,905.7V474c-1.9-62.1,7.1-120.4,26.8-174.9,19.8-54.5,47.5-102.5,83.2-143.9,35.7-41.4,78.5-75.7,128.4-103C288.5,25,342.6,7.5,400.9,0V186.2c-71.5,24.5-120.4,60.7-146.7,108.6-26.4,48-39.5,106.8-39.5,176.3h186.2v434.5H.2Zm600.9,0V474c-1.9-62.1,7.1-120.4,26.8-174.9,19.8-54.5,47.5-102.5,83.2-143.9,35.7-41.4,78.5-75.7,128.4-103C889.4,25,943.5,7.5,1001.8,0V186.2c-71.5,24.5-120.4,60.7-146.7,108.6-26.4,48-39.5,106.8-39.5,176.3h186.2v434.5h-400.6Z",
    style: {
      fill: "#02b57b"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuoteMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quote-mark.c95fc836.svg";
export { ForwardRef as ReactComponent };